import Request from 'src/utils/request'

/**
 * 查询日志 logType 1数据更新日志 2操作日志 3维护日志
 * @param {*} data
 */
export function getCommonLogsApi (params) {
  return Request({
    url: '/common_logs',
    params,
  })
}
